import {
    createSlatePlugin,
    createTSlatePlugin,
    type PluginConfig,
} from '@udecode/plate';
import {
    type TriggerComboboxPluginOptions,
    withTriggerCombobox,
} from '@udecode/plate-combobox';

import type { TShortcutElement } from './types';
  
export type ShortcutConfig = PluginConfig<
    'shortcut',
    {
        insertSpaceAfterShortcut?: boolean;
    } & TriggerComboboxPluginOptions,
    {},
    {
        insert: {
            shortcut: (options: { search: string; value: any; key?: any }) => void;
            shortcutInput: (options: { search: string; value: any }) => void;
        };
    }
  >;
  
export const BaseShortcutInputPlugin = createSlatePlugin({
    key: 'shortcut_input',
    node: { isElement: true, isInline: true, isVoid: true },
});
  
/** Enables support for autocompleting @shortcuts. */
export const BaseShortcutPlugin = createTSlatePlugin<ShortcutConfig>({
    key: 'shortcut',
    node: { isElement: true, isInline: true, isMarkableVoid: true, isVoid: true },
    options: {
        trigger: '@',
        triggerPreviousCharPattern: /^\s?$/,
        createComboboxInput: (trigger) => ({
            children: [{ text: '' }],
            trigger,
            type: BaseShortcutInputPlugin.key,
        }),
    },
    plugins: [BaseShortcutInputPlugin],
})
    .extendEditorTransforms<ShortcutConfig['transforms']>(({ editor, type }) => ({
        insert: {
            shortcut: ({ key, value }) => {
                editor.tf.insertNodes<TShortcutElement>({
                    key,
                    children: [{ text: '' }],
                    type,
                    ref: value,
                });
            },
            shortcutInput: ({ search, value }) => {
                editor.tf.insertNodes({
                    type: BaseShortcutInputPlugin.key,
                    children: [{ text: search }],
                    ref: value,
                });
            }
        },
    }))
    .overrideEditor(withTriggerCombobox as any);

